'use client';

import dynamic from 'next/dynamic';

/** The widget's code loads in the browser only; same height while it loads. */
const BitycleCalendarLazy = dynamic(
    () => import('@/components/(blog)/post/calendar/BitycleCalendar'),
    {
        ssr: false,
        loading: () => (
            <div className='-mx-4 h-[560px] animate-pulse bg-gray-100 dark:bg-white/5 lg:mx-0 lg:h-[640px] lg:rounded-xl' />
        ),
    },
);

export default BitycleCalendarLazy;
